<div class='menu'>
  <div class='top'>
    <div class='header'>
      <img class='logo' src='assets/imgs/music-together-logo.png' (click)='commands.gotoMusicTogether(this)'>
      <button class='close' (click)='dismiss()'><i class='mt-cancel'></i></button>
    </div>

    <div class='lesson-plans'>
      <button [ngClass]='{"underlined": isLessonPlans}' (click)='commands.gotoLessonPlansPage(this)'>Lesson Plans</button>
    </div>

    <div class='resources'>
      <div class="expand-btn" (click)="onResourceExpansion()">
        <h2>Resources</h2>
        <span class="label-margin" [ngClass]="isResourceExpanded ? 'mt-arrow-up': 'mt-arrow-down'"></span>
      </div>
      <div class="list" *ngIf="isResourceExpanded">
        <button [ngClass]='{"underlined": isVideoLibrary}' (click)='commands.gotoVideoLibraryPage(this)'>Video Library</button>
        <button [ngClass]='{"underlined": isPemLibrary}' (click)='commands.gotoParentEducationPage(this)'>PEM Library</button>
        <button [ngClass]='{"underlined": isTeacherNotes}' (click)='commands.gotoTeacherNotesPage(this)'>Teacher Blog</button>
        <button [ngClass]='{"underlined": isTeachingTools}' (click)='commands.gotoTeachingToolsPage(this)'>Teaching Tools</button>
        <button [ngClass]='{"underlined": isTrainings}' (click)='commands.gotoTrainingPage(this)'>Trainings/Workshops</button>
        <ng-container *ngFor='let page of resourcePages(); trackBy: trackByUuid'>
          <button (click)='commands.gotoPagesPage(this, page)'>{{page.title}}</button>
        </ng-container>
      </div>
    </div>

    <div class='lesson-plans'>
      <button [ngClass]='{"underlined": isLessonPlans}' (click)='commands.gotoTeacherNotesPage(this)'>Teacher Blog</button>
    </div>

    <div class="pages">
      <!-- <h2>Pages</h2> -->
      <app-pages-navigation [pages]=this.teacher.pages [ngClass]='{"mobile-menu": true}' [showChildren]="false"></app-pages-navigation>
      <!-- <ng-container *ngFor='let page of this.teacher.pages; trackBy: trackByUuid'>
        <button [ngClass]='{"underlined": isPages && isCurrentPage(page.slug), "nested": isChildPage(page)}' (click)='commands.gotoPagesPage(null, page)'>{{page.title}}</button>
      </ng-container> -->
    </div>

    <div class='extras'>
      <button (click)='commands.enterAccessCode(this)'>Access Code</button>
      <button (click)='commands.gotoFacebook(this)'>Facebook Group</button>
      <button (click)='commands.feedback(this)'>Contact Us</button>
      <button (click)='commands.reloadApp(this)'>Reload App</button>
      <button class='logout' (click)='commands.logout(this)'>Log Out</button>
    </div>
  </div>

  <!-- <div class='bottom'> -->
    <!-- <p class="hello">Hello, {{teacher.user.name}}!</p> -->
    <!-- <div class='separator'></div> -->
    <!-- <button class='logout' (click)='commands.logout(this)'>Log Out</button> -->
  <!-- </div> -->
</div>